module.exports = __webpack_public_path__ + "static/media/dogs_real_square.126ccdb6.png";